<template>
    <button :disabled="!disabled" :class="{ 'opacity-25 cursor-not-allowed': !disabled }" class="btn-green ml-8 mt-8 mb-8 items-center">
        <div v-if="loading" class="btn-spinner mr-2 md:inline-block"/>
        <slot/>
    </button>
</template>

<script>
export default {
    props: {
        loading: Boolean,
        disabled: Boolean,
    },
}
</script>
